<!--报表 销售退货单 详情-->
<template>
  <div id="stockdetail">
    <el-row>
      <el-col :span="12">
        <ul>
          <li>客户名称：{{ tableData.TITLE.TC_NAME }}</li>
          <li>
            项&nbsp;&nbsp;&nbsp;&nbsp;目&nbsp;&nbsp;&nbsp;&nbsp;点：{{
              tableData.TITLE.PJ_NAME
            }}
          </li>
          <li>档口：{{ tableData.TITLE.DK_NAME }}</li>
        </ul>
      </el-col>
      <el-col :span="12">
        <ul>
          <li>订单编号：{{ tableData.TITLE.ORDER_CODE }}</li>
          <li>退货日期：{{ tableData.TITLE.RETURN_DAY }}</li>
          <li>退货总金额：{{ tableData.TITLE.TOTAL_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData.DATA" :span-method="objectSpanMethod" stripe border @selection-change="handleSelectionChange" style="width: 100%">
          <el-table-column label="退货产品 ">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="NAME" label="产品名称"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="PRODUCT_PRICE" label="产品价格"></el-table-column>
            <el-table-column prop="RETURN_COUNT" label="退货数量"></el-table-column>
            <el-table-column prop="RETURN_FEE" label="退货总金额"></el-table-column>
            <el-table-column prop="REASON" label="退库理由"></el-table-column>
          </el-table-column>
          <el-table-column label="出库产品 ">
            <el-table-column prop="DELIVER_PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="DELIVER_TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="DELIVER_PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="BATCH" label="批次"></el-table-column>
            <el-table-column prop="DELIVER_PRODUCT_PRICE" label="出库产品单价"></el-table-column>
            <el-table-column prop="DELIVER_PRODUCT_COUNT" label="出库产品数量"></el-table-column>
          </el-table-column>
          <el-table-column type="selection" width="50" fixed="right" :selectable="selectable"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" style="margin-top: 20px">
        <el-button @click="toPrintTable">打印退货单</el-button>
      </el-col>
      <el-col :span="22">
        <el-button style="margin-top: 20px; float: right" type="primary" @click="retuenWare">退库</el-button>
      </el-col>
    </el-row>
    <!-- 退货模态框 -->
    <el-dialog title="退库信息" center :visible.sync="returnVisible" width="800px" @close="handerClose()">
      <el-table :data="returnList" border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="是否拆箱" align="center" prop="switchStatus">
          <template slot-scope="scope">
            <el-switch :disabled="!scope.row.IS_UNPACK_PRODUCT" @change="changeState($event, scope.row)" v-model="scope.row.switchStatus">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="switchStatus" label="产品名称" min-width="100">
          <template slot-scope="scope">
            <span v-show="!scope.row.switchStatus">{{ scope.row.DELIVER_PRODUCT_NAME }}</span>
            <span v-show="scope.row.switchStatus">{{ scope.row.NAME }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="switchStatus" label="产品编号" min-width="100">
          <template slot-scope="scope">
            <span v-show="!scope.row.switchStatus">{{ scope.row.DELIVER_PRODUCT_CODE }}</span>
            <span v-show="scope.row.switchStatus">{{ scope.row.PRODUCT_CODE }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="switchStatus" label="单位" width="80">
          <template slot-scope="scope">
            <span v-show="!scope.row.switchStatus">{{ scope.row.DELIVER_TYPE_UNIT }}</span>
            <span v-show="scope.row.switchStatus">{{ scope.row.TYPE_UNIT }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="switchStatus" width="140">
          <template slot="header">
            <span>数量</span>
          </template>
          <template slot-scope="scope">
            <span v-show="!scope.row.switchStatus">出库:&nbsp;{{ scope.row.DELIVER_PRODUCT_COUNT }}</span>
            <span v-show="scope.row.switchStatus">退货:&nbsp;{{ scope.row.RETURN_COUNT }}</span>
          </template>
        </el-table-column>
        <el-table-column label="退库数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COUNT" @change.native="Count($event, scope.row)"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column label="退库原因">
          <template slot-scope="scope">
            <el-input v-model="scope.row.REASON"></el-input>
          </template>
        </el-table-column> -->
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="returnClose">取 消</el-button>
        <el-button size="small" :disabled="this.按钮禁用" @click="submitReturn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { print } from 'api/warehouseManager';
import http from '@/assets/common/http';
import util from '../../assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      // 金额
      按钮禁用: false,
      totalFee: '',
      realFee: '',
      // 拉取数据
      tableData: {
        DATA: [],
        TITLE: {},
      },
      spanArr: [],
      position: 0,
      checkedArray: [],
      returnVisible: false,
      returnList: [],
      submitArr: [],
      SUPPLIER_ID: '',
      PrintingArray: [],
      DELIVER_SUPPLIER_ID: sessionStorage.getItem('tcId'),
    };
  },
  methods: {
    handerClose() {
      this.returnList.forEach((item) => {
        this.$set(item, 'COUNT', '');
      });
    },
    changeState(switchStatus, row) {
      if (row.COUNT) {
        row.COUNT = '';
      }
    },
    Count(e, row) {
      // 此处不考虑同一产品不同批次出库造成的一个拆箱一个不拆箱的情况
      let unit = '';
      if (row.switchStatus === true) {
        unit = row.TYPE_UNIT;
      } else {
        unit = row.DELIVER_TYPE_UNIT;
      }
      if (util.JudgmentUnit(unit)) {
        if (!validation.数量正数验证(Number(e.target.value))) {
          this.$message.show({ text: '请输入正确的值', type: 'warning' });
          this.按钮禁用 = true;
          return;
        }
      } else {
        if (!validation.数量整数正数验证(Number(e.target.value))) {
          this.$message.show({ text: '请输入整数的值', type: 'warning' });
          this.按钮禁用 = true;
          return;
        }
      }
      if (row.switchStatus) { // 拆箱
        if (Number(row.RETURN_COUNT) < Number(e.target.value)) {
          this.$message.show({ text: '退库数量不能大于退货数量!', type: 'warning' });
          this.按钮禁用 = true;
          return;
        }
        let tempCount = 0;
        this.returnList.forEach((item) => {
          if (item.PRODUCT_CODE === row.PRODUCT_CODE && item.switchStatus === true) {
            if (item.COUNT) {
              tempCount += Number(item.COUNT);
              if (tempCount > Number(row.RETURN_COUNT)) {
                this.$message.show({ text: '退库数量不能大于退货数量!', type: 'warning' });
                this.按钮禁用 = true;
              }
            }
          }
        });
      } else {
        if (Number(row.DELIVER_PRODUCT_COUNT) < Number(e.target.value)) {
          this.$message.show({ text: '退库数量不能大于出库数量!', type: 'warning' });
          this.按钮禁用 = true;
          return;
        }
      }
      this.按钮禁用 = false;
    },
    // 拉取数据
    getRecordDetail() {
      const params = {
        SERVICE_ID: '10028',
        OTYPE: 21,
        ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result;
          this.spanArr = [];
          this.rowspan();
          this.SUPPLIER_ID = this.tableData.TITLE.SUPPLIER_ID;
          this.unique();
        } else {
          this.tableData = {};
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------------行
    rowspan() {
      this.tableData.DATA.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.tableData.DATA[index].RETURN_ORDER_DETAIL_ID === this.tableData.DATA[index - 1].RETURN_ORDER_DETAIL_ID) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    // ---------------------------------表格合并行
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 3) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 4) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 5) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 6) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 7) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main">';
      html += `<div class="title">${sessionStorage.getItem('company')}销售退货单</div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">项目点：${this.tableData.TITLE.PJ_NAME}</div><div style="font-size: 20px;">档口：${this.tableData.TITLE.DK_NAME}</div><div style="font-size: 20px;">退货日期：${this.tableData.TITLE.RETURN_DAY}</div></div>`;
      html += `<div class="head" style="font-size: 20px;">供应商：${sessionStorage.getItem('company')}</div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">订单编号：${this.tableData.TITLE.ORDER_CODE}</div><div style="font-size: 20px;">总金额：${this.tableData.TITLE.TOTAL_FEE}</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr><th style="width: 50px">序号</th> <th>产品名称</th> <th>产品编码</th> <th  style="width: 40px">单位</th> <th style="width: 70px">产品价格</th> <th  style="width: 70px">退货数量</th> <th  style="width: 70px">退货金额</th></tr>';
      html += '</div><div class="el-table__body">';
      this.PrintingArray.forEach((item, index) => {
        html += '<tr style="text-align: center">';
        html += `<td> ${index + 1} </td> <td>${item.NAME}</td>  <td>${item.PRODUCT_CODE}</td> <td>${item.TYPE_UNIT}</td>
                 <td>${item.PRODUCT_PRICE}</td> <td>${item.RETURN_COUNT}</td> <td>${item.RETURN_FEE}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += '<div style="margin-top: 20px; display: flex; flex-direction: row;"><div style="font-size: 20px;">退货人：</div><div style="margin-left: 200px; font-size: 20px;">主管：</div></div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
    // 退货
    retuenWare() {
      if (this.checkedArray.length !== 0) {
        this.returnList = this.checkedArray;
        this.returnList.forEach((item) => {
          this.$set(item, 'switchStatus', false);
        });
        this.returnVisible = true;
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    // 多选框
    selectable(row, index) {
      if (row.CAN_RETURN == 0) {
        return false;
      }
      return true;
    },
    handleSelectionChange(val) {
      this.checkedArray = val;
    },
    returnClose() {
      this.returnVisible = false;
    },
    submitReturn() {
      for (let i = 0; i < this.returnList.length; i++) {
        if (
          Number(this.returnList[i].COUNT) > Number(this.returnList[i].switchStatus ? this.returnList[i].RETURN_COUNT : this.returnList[i].DELIVER_PRODUCT_COUNT)
          || Number(this.returnList[i].COUNT) < 0 || this.returnList[i].COUNT === undefined) {
          this.$message.show({ text: '请合理填写退库数量', type: 'warning' });
          return false;
        }
      }
      if (document.body.style.cursor === 'wait') {
        return;
      }
      document.body.style.cursor = 'wait';
      try {
        const submitArr = this.returnList.map((item) => ({
          RETURN_COUNT: item.COUNT,
          BATCH: item.BATCH,
          DELIVER_DETAIL_ID: item.DELIVER_DETAIL_ID,
          ID: item.ID,
          SUPPLIER_ID: this.SUPPLIER_ID,
          DELIVER_SUPPLIER_ID: Number(this.DELIVER_SUPPLIER_ID),
          PRODUCT_CODE: item.PRODUCT_CODE,
          DELIVER_PRODUCT_CODE: item.DELIVER_PRODUCT_CODE,
        }));
        const params = {
          SERVICE_ID: '10028',
          OTYPE: 22,
          RETURN_DATA: submitArr,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.getRecordDetail();
          this.returnVisible = false;
          document.body.style.cursor = 'default';
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          document.body.style.cursor = 'default';
        });
      } finally {}
      this.returnVisible = false;
    },
    // 打印功能去重
    unique() {
      if (!Array.isArray(this.tableData.DATA)) {
        return;
      }
      const obj = {};
      const PrintingArray = this.tableData.DATA.filter((item) => (obj[item.PRODUCT_CODE] ? '' : (obj[item.PRODUCT_CODE] = true)));
      this.PrintingArray = PrintingArray;
    },
  },
  created() {
    this.getRecordDetail();
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

ul {
  list-style: none;
  min-height: 5px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/returnGoodsDetail.vue